import { IBundle } from '../modules/unsw-fhir/Bundle';

export const getLinks = (bundle: IBundle) => bundle.link || [];

export const getNextLinkStr = (bundle: IBundle): string | undefined => {
  const link = getLinks(bundle).find(link => link.relation === 'next');
  if (!link) return;
  return link.url;
};

export const getPrevLinkStr = (bundle: IBundle): string | undefined => {
  const link = getLinks(bundle).find(link => link.relation === 'previous');
  if (!link) return;
  return link.url;
};

export const getSelfLinkStr = (bundle: IBundle): string | undefined => {
  const link = getLinks(bundle).find(link => link.relation === 'self');
  if (!link) return;
  return link.url;
};
